import { REGEX_EMAIL } from '../../constants/constants';

function invalidName(value) {
  return /\s/.test(value) || value.length > 50;
}

export default function validateStaffForm(inputs = {}, isCreate = true) {
  const errors = {
    firstName: null,
    lastName: null,
    email: null,
    facility: null,
    designation: null,
    username: null,
    password: null,
    privateCredentials: null,
  };
  let error = false;

  const firstName = (inputs.firstName || '').trim();
  const lastName = (inputs.lastName || '').trim();

  if (inputs.privateCredentials) {
    if (!firstName) {
      errors.firstName = 'First name cannot be empty';
      error = true;
    } else if (invalidName(firstName)) {
      errors.firstName = 'Invalid first name';
      error = true;
    }

    if (!lastName) {
      errors.lastName = 'Last name cannot be empty';
      error = true;
    } else if (invalidName(lastName)) {
      errors.lastName = 'Invalid last name';
      error = true;
    }

    if (!inputs.designation) {
      errors.designation = 'Designation cannot be empty';
      error = true;
}

    if (!inputs.email) {
      errors.email = 'Email cannot be empty';
      error = true;
    } else if (!REGEX_EMAIL.test(inputs.email)) {
      errors.email = 'Invalid email';
      error = true;
    }
  } else {
    // Assigned: first/last optional, but if one is set both are required
    if (firstName || lastName) {
      if (!firstName) {
        errors.firstName = 'First name cannot be empty';
        error = true;
      } else if (invalidName(firstName)) {
        errors.firstName = 'Invalid first name';
        error = true;
      }

      if (!lastName) {
        errors.lastName = 'Last name cannot be empty';
        error = true;
      } else if (invalidName(lastName)) {
        errors.lastName = 'Invalid last name';
        error = true;
      }
    }

    if (!inputs.username) {
      errors.username = 'Username cannot be empty';
      error = true;
    } else if (/\s/.test(inputs.username)) {
      errors.username = 'Invalid username';
      error = true;
    }

    if (isCreate && !inputs.password) {
      errors.password = 'Password cannot be empty';
      error = true;
    }
  }

  if (!inputs.facility) {
    errors.facility = 'Facility cannot be empty';
    error = true;
  }

  return {
    errors,
    error,
  };
}
